import { TActualApplicationResponse_1 } from '../repositories/mortgage/v2/actual-application';

export type TActualApplicationStatus = 'none' | 'draft' | 'submitted';

/** Замороженный контракт для CD-277912: в этой ветке потребителя ещё нет. */
export type ISubmittedApplication = Pick<
  TActualApplicationResponse_1,
  'callSlot' | 'contact' | 'offers' | 'searchParams'
>;

/** Отправленная анкета важнее черновика, если бэк отдал оба флага. */
export const resolveActualApplication = (
  response: Pick<TActualApplicationResponse_1, 'isDraft' | 'isSubmitted'> | null,
): TActualApplicationStatus => {
  if (response?.isSubmitted) {
    return 'submitted';
  }

  return response?.isDraft ? 'draft' : 'none';
};
